import { ErrorMessage, Input, Select } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { months } from '../../../../helpers/months';
import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

const monthMessages = defineMessages({
    january: { id: '_.date_input.january', defaultMessage: 'January' },
    february: { id: '_.date_input.february', defaultMessage: 'February' },
    march: { id: '_.date_input.march', defaultMessage: 'March' },
    april: { id: '_.date_input.april', defaultMessage: 'April' },
    may: { id: '_.date_input.may', defaultMessage: 'May' },
    june: { id: '_.date_input.june', defaultMessage: 'June' },
    july: { id: '_.date_input.july', defaultMessage: 'July' },
    august: { id: '_.date_input.august', defaultMessage: 'August' },
    september: { id: '_.date_input.september', defaultMessage: 'September' },
    october: { id: '_.date_input.october', defaultMessage: 'October' },
    november: { id: '_.date_input.november', defaultMessage: 'November' },
    december: { id: '_.date_input.december', defaultMessage: 'December' }
});

export const TradingFromQuestion = () => {
    const intl = useIntl();
    const {
        register,
        formState: { errors }
    } = useFormContext<CompanyDetailsFormValues>();

    const placeholder = {
        day: intl.formatMessage({
            id: '_.date_input.day',
            defaultMessage: 'Day'
        }),
        month: intl.formatMessage({
            id: '_.date_input.month',
            defaultMessage: 'Month'
        }),
        year: intl.formatMessage({
            id: '_.date_input.year',
            defaultMessage: 'Year'
        })
    };

    const firstError =
        errors.tradingFrom?.day?.message ??
        errors.tradingFrom?.month?.message ??
        errors.tradingFrom?.year?.message;

    return (
        <FieldRow
            label={
                <FormattedMessage
                    id="_.your_company.business_trading"
                    defaultMessage="When did your business start trading?"
                />
            }
        >
            <div className="flex gap-l">
                <div className="flex-1">
                    {/* eslint-disable-next-line iwoca/input-a11y */}
                    <Input
                        {...register('tradingFrom.day')}
                        placeholder={placeholder.day}
                        className="fs-exclude"
                        data-testid="trading-from-day-input"
                    />
                </div>
                <div className="flex-[1.5]">
                    <Select
                        {...register('tradingFrom.month')}
                        placeholder={placeholder.month}
                        data-testid="trading-from-month-input"
                    >
                        {months.map(({ value, mappedValue, label }) => (
                            <option key={value} value={value}>
                                {mappedValue &&
                                monthMessages[
                                    mappedValue as keyof typeof monthMessages
                                ]
                                    ? intl.formatMessage(
                                          monthMessages[
                                              mappedValue as keyof typeof monthMessages
                                          ]
                                      )
                                    : label}
                            </option>
                        ))}
                    </Select>
                </div>
                <div className="flex-[1.5]">
                    {/* eslint-disable-next-line iwoca/input-a11y */}
                    <Input
                        {...register('tradingFrom.year')}
                        placeholder={placeholder.year}
                        className="fs-exclude"
                        data-testid="trading-from-year-input"
                    />
                </div>
            </div>
            {firstError && (
                <ErrorMessage className="mt-s">{firstError}</ErrorMessage>
            )}
        </FieldRow>
    );
};
